
import debounce from 'debounce'
import { createNamespacedHelpers } from 'vuex'
import BaseFormScope from './BaseFormScope'
import gtm from '~/mixins/gtm'
import userTypes from '~/store/user/types'

const {
  mapGetters: mapGettersUser,
} = createNamespacedHelpers('user')

export default {
  name: 'BaseFormNumberInput',
  extends: BaseFormScope,
  mixins: [
    gtm,
  ],

  props: {
    min: {
      type: Number,
      default: 1,
    },

    max: {
      type: Number,
      default: Infinity,
    },

    step: {
      type: Number,
      default: 1,
    },

    isDebounce: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      quantity: this.value,
    }
  },

  computed: {
    ...mapGettersUser({
      isMediclubMember: userTypes.GET_IS_MEDICLUB_MEMBER,
    }),
  },

  watch: {
    value (newValue) {
      this.quantity = newValue
    },
  },

  methods: {
    onMinus () {
      let value = this.quantity

      if (value > this.min) {
        value--
      }

      this.setInput(value)

      this.$emit('gtm-event', { event: 'remove_from_cart', quantity: value })
    },

    onPlus () {
      let value = this.quantity

      if (value < this.max) {
        value++
      }

      this.setInput(value)

      this.$emit('gtm-event', { event: 'add_to_cart', quantity: value })
    },

    onInput (val) {
      const gtmEvent = val > this.quantity ? 'add_to_cart' : 'remove_from_cart'

      this.$emit('gtm-event', { event: gtmEvent, quantity: val })

      let value = parseInt(val) || this.min

      if (value < this.min) {
        value = this.min
      }

      if (value > this.max) {
        value = this.max
      }

      this.setInput(value)
    },

    setInput (value) {
      if (this.isDebounce) {
        this.quantity = value
        this.emitInput(value)
      } else {
        this.$emit('input', value)
      }
    },

    emitInput: debounce(function (value) {
      this.$emit('input', value)
    }, 700),
  },
}
